import {useQuery} from "@tanstack/react-query"
import {handleError} from "helpers"
import {studentCallLogService} from "services"
import {BaseDepartmentId} from "types/departments"
import styles from "./CallLogStats.module.css"
import {ReactComponent as CallsIcon} from "./assets/calls.svg"
import {ReactComponent as StudentsIcon} from "./assets/students.svg"
import {ReactComponent as StaffsIcon} from "./assets/staffs.svg"
import {ReactComponent as RecordsIcon} from "./assets/records.svg"

type Props = {
    departmentId?: BaseDepartmentId
}

export function CallLogStats(props: Props) {
    const {departmentId} = props

    const {data} = useQuery(["call-log-stats", departmentId], () => studentCallLogService.stat({departmentId}), {
        initialData: {},
        onError: (err) => {
            handleError(err)
        }
    })

    return (
        <div className={styles.itemsWrap}>
            <div className={styles.item}>
                <CallsIcon className={styles.icon} />
                <span className={styles.title}>No. of calls</span>
                <span className={styles.value}>{data.totalCalls || 0}</span>
            </div>
            <div className={styles.item}>
                <StudentsIcon className={styles.icon} />
                <span className={styles.title}>No. of students</span>
                <span className={styles.value}>{data.totalStudents || 0}</span>
            </div>
            <div className={styles.item}>
                <StaffsIcon className={styles.icon} />
                <span className={styles.title}>No. of staffs</span>
                <span className={styles.value}>{data.totalStaffs || 0}</span>
            </div>
            <div className={styles.item}>
                <RecordsIcon className={styles.icon} />
                <span className={styles.title}>No. of records</span>
                <div className={styles.valueWrap}>
                    <span className={styles.value}>{data.totalRecords || 0}</span>
                    <span className={styles.subValue}>{`(${Math.floor(
                        (data.totalRecordsInMinutes || 0) / 60
                    )} mins)`}</span>
                </div>
            </div>
        </div>
    )
}
